export const patterns = {
  383: [3, 3, 2], // kosovo
  1: [1, 3, 3, 4], // usa/canada
  355: [2, 3, 4], // albania
};

const COUNTRY_FORMATS = {
  // Albania
  355: {
    rules: [
      { test: /^4/, pattern: [1, 3, 4] }, // Tirana landline
      { test: /^6/, pattern: [2, 3, 4] }, // Mobile
    ],
    default: [2, 3, 3],
  },
  // Kosovo
  383: {
    default: [2, 3, 3],
  },
  // USA / NANP
  1: {
    default: [3, 3, 4],
  },
};

/**
 * Format phone numbers for supported countries (and reasonable fallback).
 * @param {string} raw - input (can include +, spaces, dashes, parentheses)
 * @returns {Object} { countryCode, international: "+<cc> ...", national: "..." }
 */
export const formatPhoneNumber = (raw) => {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return "";

  // detect country code
  const knownCCs = Object.keys(COUNTRY_FORMATS).sort(
    (a, b) => b.length - a.length
  );
  let cc =
    knownCCs.find((code) => digits.startsWith(code)) || digits.slice(0, 1);

  const spec = COUNTRY_FORMATS[cc] || { default: [3, 3, 3] };
  const nsn = digits.slice(cc.length);

  // choose matching pattern or fallback
  let pattern = spec.default;
  if (spec.rules) {
    const match = spec.rules.find((r) => r.test.test(nsn));
    if (match) pattern = match.pattern;
  }

  // group according to pattern
  const groups = [];
  let rest = nsn;
  for (let size of pattern) {
    if (!rest) break;
    groups.push(rest.slice(0, size));
    rest = rest.slice(size);
  }
  if (rest) groups.push(rest);

  return `+${cc} ${groups.join(" ")}`;
};
